/*
 * Reports Messages
 *
 * This contains all the text for the Reports component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.containers.Reports.header',
    defaultMessage: 'Reports',
  },
  circuitReport: {
    id: 'app.containers.Reports.circuitReport',
    defaultMessage: 'Circuit Report',
  },
  branchReport: {
    id: 'app.containers.Reports.branchReport',
    defaultMessage: 'Branch Office Report',
  },
  monthReport: {
    id: 'app.containers.Reports.monthReport',
    defaultMessage: 'Monthly Report',
  },
});
